const createDashboardChartDragGhost = (card, event) => {
	const rect = card.getBoundingClientRect();
	const title = card.querySelector('.dashboard-home-chart-card__title')?.textContent?.trim() ?? '报表';
	const previewEl = card.querySelector('.dashboard-home-chart-card__preview');
	const previewHeight = previewEl ? Math.round(previewEl.getBoundingClientRect().height) : 120;

	const host = document.createElement('div');
	host.className = 'dashboard-home-chart-card__drag-ghost-host';
	host.style.position = 'fixed';
	host.style.top = '-9999px';
	host.style.left = '0';
	host.style.zIndex = '10000';
	host.style.pointerEvents = 'none';

	const bsTheme = document.documentElement.getAttribute('data-bs-theme');
	if (bsTheme) {
		host.setAttribute('data-bs-theme', bsTheme);
	}

	const ghost = document.createElement('article');
	ghost.className = 'card dashboard-home-chart-card dashboard-home-chart-card--drag-ghost';
	ghost.style.width = `${Math.round(rect.width)}px`;

	const head = document.createElement('header');
	head.className = 'card-header dashboard-home-chart-card__header bg-body-tertiary';

	const headInner = document.createElement('div');
	headInner.className = 'dashboard-home-chart-card__head-main';

	const titleNode = document.createElement('h4');
	titleNode.className = 'dashboard-home-chart-card__title mb-0';
	titleNode.textContent = title;
	headInner.appendChild(titleNode);
	head.appendChild(headInner);
	ghost.appendChild(head);

	const preview = document.createElement('div');
	preview.className = 'dashboard-home-chart-card__preview dashboard-home-chart-card__preview--ghost';
	preview.style.height = `${previewHeight}px`;
	preview.setAttribute('aria-hidden', 'true');
	ghost.appendChild(preview);

	host.appendChild(ghost);
	document.body.appendChild(host);
	void host.offsetHeight;

	const offsetX = Math.min(Math.max(event.clientX - rect.left, 24), Math.max(rect.width - 24, 24));
	const offsetY = Math.min(Math.max(event.clientY - rect.top, 20), Math.max(rect.height - 20, 20));

	return { host, offsetX, offsetY };
};

export default createDashboardChartDragGhost;
